declare global {
    interface Window {
        Intercom: (action: string) => void;
    }
}

export const openIntercom = () => {
    if (window.Intercom) {
        window.Intercom('showNewMessage');
    }
};
